<template>
  <div :style="{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }">
    <v-chip small color="primary" text-color="white" class="ma-0">{{ name || '-' }}</v-chip>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-btn icon small flat color="primary" class="ma-0" v-on="on" @click="handleEdit">
          <v-icon small>edit</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('edit_category') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    categoryId: {
      type: Number,
      default: undefined
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    name() {
      const category = this.options.find((option) => option.value === this.categoryId)
      return category ? category.text : undefined
    }
  },
  methods: {
    handleEdit() {
      this.$emit('edit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcastItemCategory.vue